import { createTheme } from "@material-ui/core";
import { baseTheme, groopTheme } from "./MaterialGroopTheme";

export const filterTheme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    primary: {
      main: groopTheme.palette.primary.dark,
    },
    secondary: {
      main: groopTheme.palette.primary.light,
    },
  },
});
